import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;

  @media ${breakpoint.md} {
    padding-top: 80px;
  }
`;
